/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Fr1_EyebrowInputs */

const en_funnel_sq_fr1_eyebrow = /** @type {(inputs: Funnel_Sq_Fr1_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read aloud, not read`)
};

const es_funnel_sq_fr1_eyebrow = /** @type {(inputs: Funnel_Sq_Fr1_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuchado, no leído`)
};

/**
* | output |
* | --- |
* | "Read aloud, not read" |
*
* @param {Funnel_Sq_Fr1_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_fr1_eyebrow = /** @type {((inputs?: Funnel_Sq_Fr1_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Fr1_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_fr1_eyebrow(inputs)
	return en_funnel_sq_fr1_eyebrow(inputs)
});